export const shopifyHelperMixin = {
    methods: {
        resizeImage: function(url, size){
            if(!url.includes('cdn.shopify.com')){
                return url;
            }
            size = size || '_400x';
//            var regex = /\.(jpg|webp|png|heic|gif)/;
//            url = url.replace(regex, size + '.$1');
            var regex = /(.*)\.(jpg|webp|png|heic|gif)/;
            url = url.replace(regex, '$1' + size + '.$2');
            return url;
        },
        formatCurrency: function(unit_amount){
            var num = unit_amount / 100; //convert to dollars
            num = num.toLocaleString('en-US', {
                style: 'currency',
                currency:'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
            return num;
        },
        setThumbnails: function(product){
            var regex = /(.*)\.(jpg|webp|png|heic|gif)/;
            for(var i=0; i < product.images.length; i++){
                var image = product.images[i];
                var src = image.src;
                var thumbnail = src.replace(regex, '$1_200x200.$2');
                Vue.set(image, 'thumbnail', thumbnail);
                if(i === 0 && !product.thumbnail){
                    Vue.set(product, 'thumbnail', thumbnail);
                }
            }
        },
    }
}


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/mixins/shopifyHelperMixin.js